import { forwardRef } from 'react';
import { VisuallyHidden as RadixVisuallyHidden } from '@radix-ui/themes';
import type { RadixComponentProps } from '@/types/radix-ui';

/**
 * VisuallyHidden component - wrapper around Radix UI VisuallyHidden
 * Provides all functionality of the original component while allowing
 * for centralized customization and future extensions.
 */
export type VisuallyHiddenProps = RadixComponentProps<
  typeof RadixVisuallyHidden
>;

const VisuallyHidden = forwardRef<HTMLSpanElement, VisuallyHiddenProps>(
  (props, ref) => {
    return <RadixVisuallyHidden ref={ref} {...props} />;
  }
);

VisuallyHidden.displayName = 'VisuallyHidden';

export { VisuallyHidden };
